import {
  HsaPayoutReportFieldGroup,
  hsaPayoutReportFieldSchema,
} from "@redotech/redo-conversion-hsa-common/payout-report/payout-report-fields";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/** One column the payout report CSV can carry, as the settings page lists it. */
export const hsaPayoutReportFieldDefinitionSchema = z.object({
  key: hsaPayoutReportFieldSchema,
  label: z.string(),
  group: createEnum(HsaPayoutReportFieldGroup),
  description: z.string(),
});
export type HsaPayoutReportFieldDefinition = z.infer<
  typeof hsaPayoutReportFieldDefinitionSchema
>;

/**
 * The team's payout report email settings. Defaults (off, no recipients, the
 * default column selection) when the team has never saved any, so the page
 * never has to special-case "no row".
 */
export const getHsaPayoutReportSettings = {
  name: "getHsaPayoutReportSettings" as const,
  input: z.null(),
  output: z.object({
    /** The merchant's switch. The report sends only when this is on and at
     * least one recipient is listed. */
    enabled: z.boolean(),
    /** Normalized addresses. */
    recipients: z.array(z.string()),
    /** In catalog order. */
    fields: z.array(hsaPayoutReportFieldSchema),
    /** The whole catalog, in file column order. */
    availableFields: z.array(hsaPayoutReportFieldDefinitionSchema),
    defaultFields: z.array(hsaPayoutReportFieldSchema),
  }),
};
